import { createContext, useContext, useEffect, useState } from 'react';
import { useColorMode } from '@chakra-ui/react';

const STORAGE_KEY = 'mi-kapital-color-preference';
const VALID = ['system', 'light', 'dark'];

const readPreference = () => {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    if (VALID.includes(v)) return v;
  } catch (e) {}
  return 'system';
};

const ColorPreferenceContext = createContext(null);

export function ColorPreferenceProvider({ children }) {
  const { setColorMode } = useColorMode();
  const [preference, setPreferenceState] = useState(readPreference);

  useEffect(() => {
    const mql = window.matchMedia('(prefers-color-scheme: dark)');

    const apply = () => {
      const mode = preference === 'system'
        ? (mql.matches ? 'dark' : 'light')
        : preference;
      setColorMode(mode);
    };

    apply();

    if (preference === 'system') {
      mql.addEventListener('change', apply);
      return () => mql.removeEventListener('change', apply);
    }
  }, [preference, setColorMode]);

  const setPreference = (pref) => {
    if (!VALID.includes(pref)) return;
    try {
      localStorage.setItem(STORAGE_KEY, pref);
    } catch (e) {}
    setPreferenceState(pref);
  };

  return (
    <ColorPreferenceContext.Provider value={{ preference, setPreference }}>
      {children}
    </ColorPreferenceContext.Provider>
  );
}

export function useColorPreference() {
  const ctx = useContext(ColorPreferenceContext);
  if (!ctx) throw new Error('useColorPreference must be used inside ColorPreferenceProvider');
  return ctx;
}
